import type { BannerType } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { mergeLeft } from 'merge-left-utils'

export interface BannerTypeFormState {
  id?: GQL_ID
  label?: string
  code?: string
}

export const BANNER_DEFAULT_STATE: BannerTypeFormState = {
  id: undefined,
  label: '',
  code: ''
}

export const makeBannerTypeFormState = (
  bannerType?: BannerType
): BannerTypeFormState => {
  return mergeLeft<BannerTypeFormState>(BANNER_DEFAULT_STATE, bannerType)
}

export const mapStateToApiVariable = (state: BannerTypeFormState): any => ({
  id: state.id,
  label: state.label,
  code: state.code
})

export const mapApiDataToState = (data: BannerType): BannerTypeFormState => ({
  id: data.id,
  label: data.label,
  code: data.code
})
